export default __webpack_public_path__ + "static/media/logo.42a44147.svg";